import { InputNumber } from '@/shared/MiInputNumber/MiInputNumber';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const toFixed = value => {
    if (value && typeof value === 'number') {
        return value.toFixed(2);
    }

    return value;
};

const CurveInfo = props => {
    const { title, type, color: defaultColor, depth: initialDepth, width, date, withDate = true, withDepth = true, id } = props;
    const linkingMode = useSelector(state => state.curveSettings.linkingMode);

    const activeItemKey = useSelector(state => state.lists.activeItemKey);

    const offset = useSelector(state => state.curveSettings.offset?.[activeItemKey]?.[id]) ?? 0;
    
    const color = useSelector(state => state.displaySettings.globalCurvesSettings[type]?.color) ?? defaultColor;

    const dispatch = useDispatch();

    const onInputChange = useCallback(
        value => {
            if (Number(value) !== offset) {
                dispatch.curveSettings.setOffsetEffect({
                    id,
                    value: Number(value) - offset,
                    tabletKey: activeItemKey,
                });
            }
        },
        [activeItemKey, id, offset]
    );

    return (
        <div className="mb-3 flex flex-row items-center justify-between gap-3">
            <span className="pl-2 text-left text-xs font-semibold" style={{ color: `${color}` }}>
                {title}
            </span>
            <div className="flex h-full flex-1 flex-col justify-center">
                {withDepth && (
                    <div className="mb-1 text-xs text-black dark:text-font-quarternary">
                        {toFixed(initialDepth + offset)}
                    </div>
                )}
                <div className="w-full" style={{ backgroundColor: color, height: width ?? 2 }} />
            </div>
            {withDate ? (
                <span className="pr-2 text-right text-xxs text-gray-700 dark:text-font-secondary">{date}</span>
            ) : null}
            {linkingMode ? (
                <InputNumber
                    step={0.2}
                    type={'number'}
                    onChange={val => onInputChange(val)}
                    value={offset.toFixed(1)}
                />
            ) : null}
        </div>
    );
};

export default CurveInfo;
